let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cp1Ee")).then(() => parcelRequire('gsn0O'));